import createLucideIcon from '../createLucideIcon';

const Send = createLucideIcon('SendIcon', [
  ['line', { x1: '22', y1: '2', x2: '11', y2: '13', key: '10auo0' }],
  ['polygon', { points: '22 2 15 22 11 13 2 9 22 2', key: '12uapv' }],
]);

export default Send;
